import api from './api';

export async function getAllSettings() {
  const response = await api.get('/getAllSettings');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data;
}

export async function updateSetting(key, value) {
  const response = await api.post('/updateSetting', { key, value });
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getDownloadLinks() {
  const response = await api.get('/getDownloadLinks');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}

export async function getNobilityReset() {
  const response = await api.get('/getNobilityReset');
  if (response.data.error !== undefined) {
    throw new Error(response.data.error);
  }
  return response.data.result;
}
